export default {
    change_password_title: "Cambiar la contraseña",
    change_password_username: 'Nombre de usuario',
    change_password_new_password: 'Nueva contraseña',
    change_password_repeat_new_password: 'Repita la nueva contraseña',
    change_password_passwords_must_match: 'Las contraseñas deben coincidir',
    change_password_it_is_necessary_to_change: 'Es necesario cambiar la contraseña',
    change_password_the_data_are_not_valid: 'Los datos no son válidos',
    change_password_password_is_changed: 'La contraseña ha sido cambiada, ahora puede conectarse normalmente',
    change_password_it_is_not_posible_change_password: 'No es posible cambiar la contraseña',
};